import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { elakayAutoText } from "../../pageInside/dataElakay";
import { PLANS } from "../plans";

// "✓ Includes <Role> Benefits" (ticket §14/§15): Provider inherits applicable USER ROYALE
// (Royalty) benefits, never Seller's -- plans.js's `includesPlanId` already encodes the correct
// target (fixed in the prior task), this component only owns the PRESENTATION: a tinted, visually
// separate panel so "included benefits" is never confused with the role's own business services
// below it. Collapsed by default; expanding shows the included plan's own groups flat (a compact
// reference list, not a second nested accordion).
const InheritedBenefits = ({ plan, isExpanded, onToggle, tr, getGroupLabel, getChipText }) => {
  if (!plan.includesPlanId) return null;
  const includedPlan = PLANS.find((p) => p.id === plan.includesPlanId);
  if (!includedPlan) return null;
  const panelId = `userstep-included-benefits-panel-${plan.id}`;

  return (
    <div className="userstep-included-benefits">
      <div className="userstep-included-benefits-row">
        <FaCheckCircle className="userstep-included-benefits-icon" style={{ color: plan.accentColor }} />
        <span className="userstep-included-benefits-label">
          {elakayAutoText("h_userstep_includes_benefits", "Includes {value0} Benefits", {
            value0: tr("title", includedPlan.titleKey, includedPlan.roleName),
          })}
        </span>
        <button
          type="button"
          className="userstep-included-benefits-toggle"
          aria-expanded={isExpanded}
          aria-controls={panelId}
          onClick={onToggle}
        >
          {isExpanded
            ? elakayAutoText("h_userstep_hide_inherited", "Hide included benefits")
            : elakayAutoText("h_userstep_view_inherited", "View included benefits")}
        </button>
      </div>
      {isExpanded && (
        <div id={panelId} className="userstep-included-benefits-panel">
          {(includedPlan.privilegeGroups || []).map((group) => (
            <div key={group.key} className="userstep-included-benefits-group">
              <span className="userstep-included-benefits-group-label">{getGroupLabel(group)}</span>
              <div className="userstep-plan-group-chips">
                {(group.items || []).map((item) => (
                  <span key={item.key} className="userstep-chip">
                    {getChipText(includedPlan.id, item)}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InheritedBenefits;
